<formio [refresh]="triggerRefresh" [form]="formSpec" [submission]="formData" (submit)="onSubmit($event)" (change)="onChange($event)"></formio>
